import { requestGet } from '@/utils/request';

const api = {
	CURRENT: '/app/workplace_current',
	PERIOD_SUMMARY: '/app/workplace_period_summary',
	ACTIVITY_CHART: '/app/workplace_activity_chart',
	CONVERSATION_CHART: '/app/workplace_conversation_chart',
	USER_PANEL_CHART: '/app/workplace_user_panel_chart',
};

export function workplaceCurrent() {
	return requestGet(api.CURRENT);
}

export function workplacePeriodSummary(period) {
	const params = { period };
	return requestGet(api.PERIOD_SUMMARY, params);
}

export function workplaceActivityChart(userFilter) {
	const params = { userFilter };
	return requestGet(api.ACTIVITY_CHART, params);
}

export function workplaceConversationChart(params) {
	return requestGet(api.CONVERSATION_CHART, params);
}

export function workplaceUserPanelChart(userFilter) {
	const params = { userFilter };
	return requestGet(api.USER_PANEL_CHART, params);
}
